module.exports = __webpack_public_path__ + "static/media/sample_holidays.1148dbd4.csv";